// extracted by mini-css-extract-plugin
export default {"overlay":"ez-z","bodyOpen":"fz-z","content":"gz-z","header":"hz-z","close":"iz-z","closeNoHeading":"jz-z"};